<template>
    <treeselect placeholder="Select workflow..." :disable-branch-nodes="true" :value="value" :options="workflows" @input="$emit('input', $event)">
        <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" class="label">
            <span class="description" v-if="node.raw.timestamp">{{formatDate(node.raw.timestamp)}} {{node.raw.description}}</span>
            <span v-else>{{node.id}}</span>
        </div>
        <div slot="value-label" slot-scope="{ node }" class="label">
            <span>{{node.raw.name}} | {{formatDate(node.raw.timestamp)}} | {{node.raw.description}}</span>
        </div>
    </treeselect>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'


export default {

    methods: {
        padZero(input){
            return ('00'+input).slice(-2);
        },
        formatDate(timestamp){
            let d = new Date(timestamp);
            return `${this.padZero(d.getDate())}.${this.padZero(d.getMonth()+1)}.${this.padZero(d.getYear()-100)} ${this.padZero(d.getHours())}:${this.padZero(d.getMinutes())}:${this.padZero(d.getSeconds())}`
        },
    },
    components: {
        
    },
    mounted(){
        this.$api.compatibilityEmit('listWorkflows', false, this.vialType, (workflows)=>{
            console.log({workflows});
            this.$set(this, 'workflows', workflows.map(w=>({
                ...w,
                id: w.name,
                children: w.versions.map(v=>({
                    ...v,
                    id: v.file,
                    name: w.name,
                })) 
            })));
        })
    },
    props: [
        'value',
        'vialType'
    ],
    data: function(){
        return {
            workflows: [],
        }
    }
}

</script>

<style lang="scss" scoped>
    @import "../colors.scss";
    
</style>
